import { Button } from '@toggle/design-system';
import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './AddAssets.module.scss';

type AddAssetsProps = {
  marginLeft?: number;
  onClick: () => void;
  dataTestId?: string;
  hideDivider?: boolean;
};

export const AddAssets = ({
  marginLeft = 4,
  onClick,
  dataTestId = 'add-assets-button',
  hideDivider = false,
}: AddAssetsProps) => {
  const { t } = useTranslation('widget');
  return (
    <div className={styles.dividerAndButtonGroup}>
      {!hideDivider && (
        <div
          className={styles.verticalDivider}
          style={{ '--margin-left': `${marginLeft}px` } as CSSProperties}
        />
      )}
      <Button
        className={styles.styledButton}
        variant="empty"
        size="xsmall"
        iconName="Add"
        label={t('widget:sendAllAssetsTo.add')}
        onClick={onClick}
        data-testid={dataTestId}
      />
    </div>
  );
};
